import { type BasicTaskHandlerSchema } from 'modules/procurement/components/procurementTypes/Workflows/sidePanels/schemas/basicTaskHandler'
import { HandlerFormComponentPayload } from 'modules/workflows/contexts/WorkflowContext'
import { DEFAULT_DURATION_UNIT, isValidDateUnit } from 'modules/workflows/lib/durationUnit'

import { mapEmployeeSegments } from './employeeSegmentMapper'

export const basicTaskApproveNodeToSchemaMapper = (
  payload: HandlerFormComponentPayload
): BasicTaskHandlerSchema['nodeData']['payload'] => {
  const employee_ids = payload.employee_ids
  const due_on_unit = String(payload.due_on_unit)
  const due_on_value = payload.due_on_value
  const numericDueOnValue =
    typeof due_on_value === 'number' && !isNaN(due_on_value) ? due_on_value : 1

  const employeeIds = Array.isArray(employee_ids)
    ? employee_ids.map((employee_id) => Number(employee_id))
    : []

  const fallbackEmployeeIds = Array.isArray(payload.fallback_employee_ids)
    ? payload.fallback_employee_ids.map((id) => Number(id))
    : undefined

  const assigneeSegments = mapEmployeeSegments(payload.employee_segments)
  const fallbackAssigneeSegments = mapEmployeeSegments(payload.fallback_employee_segments)

  return {
    category: 'finance',
    due_on_unit: isValidDateUnit(due_on_unit) ? due_on_unit : DEFAULT_DURATION_UNIT,
    due_on_value: numericDueOnValue,
    employee_ids: employeeIds,
    title: String(payload.title ?? ''),
    description: String(payload.description ?? ''),
    ...(assigneeSegments && assigneeSegments.length > 0
      ? { employee_segments: assigneeSegments }
      : {}),
    ...(fallbackEmployeeIds && fallbackEmployeeIds.length > 0
      ? { fallback_employee_ids: fallbackEmployeeIds }
      : {}),
    ...(fallbackAssigneeSegments && fallbackAssigneeSegments.length > 0
      ? { fallback_employee_segments: fallbackAssigneeSegments }
      : {}),
  }
}
